import React, { FC, useEffect } from "react";

// Hooks
import { PaymentFlowLayout } from "../../../Components/Layouts/PaymentFlowLayout/PaymentFlowLayout";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { usePayFlow } from "@modules/PaymentProcessing/hooks/usePayFlow";
import { PaymentMethodSelect } from "@modules/PaymentProcessing/Components/PaymentMethodSelect/PaymentMethodSelect";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { BackLink } from "@Shared/Components/BackLink/BackLink";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";

export const ChoosePaymentMethod: FC = () => {
  const {
    state: { operationSummary, allowedPaymentMethods, enabledPaymentMethods },
    navigateToStep,
    onPageMount,
    backRoute,
  } = usePayFlow();
  const navigate = useNavigate();

  const handlePaymentMethodSelect = (paymentMethod: PaymentMethodType) => {
    navigateToStep("CONFIGURE_PAYMENT", {
      queryParams: {
        ...backRoute.queryParams,
        paymentMethod,
      },
    });
  };

  useEffect(() => {
    onPageMount?.("CHOOSE_PAYMENT_METHOD");
  }, []);

  const handleBack = () => {
    navigate(backRoute.to, backRoute);
  };

  return (
    <PaymentFlowLayout>
      <PaymentFlowLayout.Nav>
        <BackLink onClick={handleBack} />
      </PaymentFlowLayout.Nav>
      <PaymentFlowLayout.OperationSummary>
        {operationSummary}
      </PaymentFlowLayout.OperationSummary>
      <PaymentFlowLayout.Header>
        <FormattedMessage {...messages.chooseYourPaymentMethod} />
      </PaymentFlowLayout.Header>
      <PaymentFlowLayout.Content>
        <PaymentMethodSelect
          onSelect={handlePaymentMethodSelect}
          allowedPaymentMethods={allowedPaymentMethods}
          enabledPaymentMethods={enabledPaymentMethods}
        />
      </PaymentFlowLayout.Content>
    </PaymentFlowLayout>
  );
};
